import { US_STATES } from "./us-states";

const STATE_CODES = new Map(
  US_STATES.flatMap((state) => [
    [state.code.toLowerCase(), state.code],
    [state.name.toLowerCase(), state.code],
    [state.slug.toLowerCase(), state.code],
  ]),
);

function stateCode(part: string): string | null {
  return STATE_CODES.get(part.trim().toLowerCase()) ?? null;
}

/** Drop a repeated place token. "FL, FL" becomes "FL". */
export function collapseRepeatedPlace(value: string): string {
  const unique: string[] = [];
  for (const part of value.split(",")) {
    const trimmed = part.trim();
    if (!trimmed) continue;
    if (unique.some((item) => item.toLowerCase() === trimmed.toLowerCase())) continue;
    unique.push(trimmed);
  }
  return unique.join(", ");
}

/**
 * A city, or a city with a state. A state by itself, or the same state twice,
 * is not a location.
 */
export function usablePlace(value: string | null | undefined): string | null {
  const collapsed = collapseRepeatedPlace(value ?? "");
  if (!collapsed) return null;
  const parts = collapsed.split(",").map((part) => part.trim()).filter(Boolean);
  if (parts.length === 0 || parts.every((part) => stateCode(part))) return null;
  return collapsed;
}
